import api from '@/utils/api'

function pickUploadedUrl(res) {
  if (!res || typeof res !== 'object') return ''
  const d = res.data && typeof res.data === 'object' ? res.data : null
  const img = (d && d.image) || res.image
  const pub =
    (d && d.public_url) ||
    res.public_url ||
    (img && typeof img === 'object' ? img.public_url : '') ||
    ''
  if (typeof pub === 'string' && pub.trim()) return pub.trim()
  const url =
    (d && d.url) ||
    res.url ||
    (img && typeof img === 'object' ? img.url : '') ||
    ''
  if (typeof url === 'string' && url.trim()) return url.trim()
  return ''
}

/**
 * 上传图片/视频到后端 /video_images，返回可访问 URL（落盘；不自动写入资产库，需用户手动加入）
 *
 * @param {Object} opts
 * @param {string} opts.image dataURL（data:image/...;base64,...）或纯 base64
 * @param {string} [opts.title]
 */
export async function uploadVideoImage(opts) {
  const image = opts?.image != null ? String(opts.image) : ''
  const title = opts?.title != null ? String(opts.title) : ''
  const relative = opts && opts.relative != null ? !!opts.relative : true
  if (!image.trim()) throw new Error('缺少 image')
  const res = await api.post('/video_images', {
    image,
    relative: relative ? 1 : 0,
    ...(title.trim() ? { title: title.trim() } : {})
  })
  const picked = pickUploadedUrl(res)
  if (picked) return picked
  throw new Error(res?.message || res?.msg || '上传失败')
}

/**
 * multipart 上传任意媒体文件到 /video_images（后端 FastMovieController@uploadImage）
 * 适合视频：避免把整段视频转 base64。
 *
 * @param {{ file: File|Blob, filename?: string, title?: string }} opts
 */
export async function uploadVideoMediaFile(opts) {
  const file = opts?.file
  if (!file) throw new Error('缺少 file')
  const filename = opts?.filename != null ? String(opts.filename) : 'upload.bin'
  const title = opts?.title != null ? String(opts.title) : ''
  const relative = opts && opts.relative != null ? !!opts.relative : true

  const fd = new FormData()
  // Laravel 常见字段名：file
  fd.append('file', file, filename)
  if (title.trim()) fd.append('title', title.trim())
  fd.append('relative', relative ? '1' : '0')

  // 不要手动设置 multipart boundary；交给浏览器自动补全
  const res = await api.post('/video_images', fd)

  const picked = pickUploadedUrl(res)
  if (picked) return picked
  throw new Error(res?.message || res?.msg || '上传失败')
}

